
import React from 'react'
import { profile_opts } from './mock'
import { ProfileItem } from './profileItem'

export const Profiles = () => {
    const [profiles] = React.useState(profile_opts)
    return (
        <div className="profiles">
            <ul>
                {
                    profiles?.length > 0 && profiles.map((item,i)=>(
                        <ProfileItem item={item} key={'profiles'+i} />
                    ))
                }
            </ul>

        </div>
    )

}